<template>

</template>

<script>
    import { login, doctor } from '../../config/api.js';
    export default {
         data() {
            return {
                data: {
                    'rut': '11111111-1',
                    'password': 'demo123',
                    'type': {name:'healt_provider',value:'Prestador'},
                    'prefix': this.$route.params.country.toUpperCase()
                },
                process: false,
                route: {
                    doctor : doctor,
                }
            }
        },
        created() {
            let self = this;
            // Authentication login
            this.$http.post('login', this.data)
                .then(function(response){
                    let data = response.data.data;
                    self.$auth.setToken(data.access_token, (data.expires_in + parseInt(Date.now()/1000)));
                    if(data.user.type == 'healt_provider'){
                        self.$router.push({'name': 'Office'});
                    }else{
                        self.$router.push({'name': 'Doctor'});
                    }
                }).catch(function(error){
                    if (error.response) {
                        console.log(error);
                        alert("Error generic");
                    } else if (error.request) {
                        console.log(error.request);
                        alert("Error empty");
                    } else {
                        console.log('Error', error.message);
                        alert("Error");
                    }
                });
        },
    }
</script>


// WEBPACK FOOTER //
// Demo.vue?5c37689b